import beijing from '@/charts/geo/beijing.js'
// import HK from '@/charts/geo/HK.js'
export default {
    beijing,
    // HK,
}


// WEBPACK FOOTER //
// ./src/model/chartMap.js